import sanitizeHtml from "sanitize-html";

/** Strips scripts, event handlers and javascript: URLs from rich content (blog/product HTML). */
export function sanitizeRichHtml(html: string | null | undefined): string {
  if (!html) return "";
  return sanitizeHtml(html, {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat([
      "img", "video", "source", "figure", "figcaption", "h1", "h2", "span", "picture",
    ]),
    allowedAttributes: {
      "*": ["class", "id", "style", "title", "aria-label"],
      a: ["href", "name", "target", "rel"],
      img: ["src", "srcset", "sizes", "alt", "width", "height", "loading", "decoding"],
      video: ["src", "poster", "controls", "playsinline", "muted", "loop", "autoplay", "preload", "width", "height"],
      source: ["src", "srcset", "type", "media"],
      td: ["colspan", "rowspan"],
      th: ["colspan", "rowspan", "scope"],
    },
    allowedSchemes: ["http", "https", "mailto", "tel"],
    allowedSchemesByTag: { img: ["http", "https", "data"] },
    allowProtocolRelative: false,
  });
}
